module.exports = __webpack_public_path__ + "img/1. Impact of the transition to electrical vehicles.3040de8d.jpg";